export default ({ request }) => ({
  ecomHxShipmentJdListApi(data = {}) {
    return request({
      url: '/ecom/hx/shipment/jd/list',
      method: 'POST',
      data,
    })
  },
  ecomHxShipmentJdDetailApi(data = {}) {
    return request({
      url: '/ecom/hx/shipment/jd/detail',
      method: 'POST',
      data,
    })
  },
  ecomHxShipmentJdSaveApi(data = {}) {
    return request({
      url: '/ecom/hx/shipment/jd/save',
      method: 'POST',
      data,
    })
  },
  ecomHxShipmentJdChangeApi(data = {}) {
    return request({
      url: '/ecom/hx/shipment/jd/change',
      method: 'POST',
      data,
    })
  },
  ecomHxShipmentJdDelApi(data = {}) {
    return request({
      url: '/ecom/hx/shipment/jd/del',
      method: 'POST',
      data,
    })
  },
  ecomHxShipmentJdConfirmPlanApi(data = {}) {
    return request({
      url: '/ecom/hx/shipment/jd/confirmPlan',
      method: 'POST',
      data,
      timeout: 30000,
    })
  },
  ecomHxShipmentJdConfirmVehicleApi(data = {}) {
    return request({
      url: '/ecom/hx/shipment/jd/confirmVehicle',
      method: 'POST',
      data,
    })
  },
  ecomHxShipmentJdChangePlanApi(data = {}) {
    return request({
      url: '/ecom/hx/shipment/jd/changePlan',
      method: 'POST',
      data,
    })
  },
  ecomHxShipmentJdCompleteApi(data = {}) {
    return request({
      url: '/ecom/hx/shipment/jd/complete',
      method: 'POST',
      data,
    })
  },
  ecomHxShipmentJdOrderFilesListApi(data = {}) {
    return request({
      url: '/ecom/hx/shipment/jd/order/files/list',
      method: 'POST',
      data,
    })
  },
  ecomHxShipmentJdOrderFilesUploadApi(data = {}) {
    return request({
      url: '/ecom/hx/shipment/jd/order/files/upload',
      method: 'POST',
      data,
    })
  },
  ecomHxShipmentJdOrderFilesDelApi(data = {}) {
    return request({
      url: '/ecom/hx/shipment/jd/order/files/del',
      method: 'POST',
      data,
    })
  },
  ecomHxShipmentJdVehicleListApi(data = {}) {
    return request({
      url: '/ecom/hx/shipment/jd/vehicle/list',
      method: 'POST',
      data,
    })
  },
  ecomHxShipmentJdVehicleDetailApi(data = {}) {
    return request({
      url: '/ecom/hx/shipment/jd/vehicle/detail',
      method: 'POST',
      data,
    })
  },
  ecomHxShipmentJdVehicleSaveApi(data = {}) {
    return request({
      url: '/ecom/hx/shipment/jd/vehicle/save',
      method: 'POST',
      data,
    })
  },
  ecomHxShipmentJdVehicleDelApi(data = {}) {
    return request({
      url: '/ecom/hx/shipment/jd/vehicle/del',
      method: 'POST',
      data,
    })
  },
  ecomHxShipmentJdOrderListApi(data = {}) {
    return request({
      url: '/ecom/hx/shipment/jd/order/list',
      method: 'POST',
      data,
    })
  },
  ecomHxShipmentJdOrderPageListApi(data = {}) {
    return request({
      url: '/ecom/hx/shipment/jd/order/page/list',
      method: 'POST',
      data,
    })
  },
  ecomHxShipmentJdOrderDetailApi(data = {}) {
    return request({
      url: '/ecom/hx/shipment/jd/order/detail',
      method: 'POST',
      data,
    })
  },
  ecomHxShipmentJdOrderRemoveVehicleApi(data = {}) {
    return request({
      url: '/ecom/hx/shipment/jd/order/removeVehicle',
      method: 'POST',
      data,
    })
  },
  ecomHxShipmentJdOrderDetailListApi(data = {}) {
    return request({
      url: '/ecom/hx/shipment/jd/order/detail/list',
      method: 'POST',
      data,
    })
  },
  ecomHxShipmentJdItemNoSearchApi(data = {}) {
    return request({
      url: '/ecom/hx/shipment/jd/item/no/search',
      method: 'POST',
      data,
    })
  },
  ecomHxShipmentUpdateQtyApi(data = {}) {
    return request({
      url: '/ecom/hx/shipment/jd/update/qty',
      method: 'POST',
      data,
    })
  },
})
